import PositionsList from 'components/Lists/ListView/PositionsList';
import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import React, { useContext, useState } from 'react';
import { ISubCategoryContext, SubCategoryContext } from '../../../../../subCategoryState/subCategoryContext';
import { RequestEntity, IItemSubCategory } from 'types';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import DataController from 'components/DataController/DataController';
import Info from './components/Info/Info';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IItemSubCategory;
	index: number;
}

const Item: React.FC<IProps> = ({ data, index }) => {
	const { setIDForDeletion } = useContext<ISubCategoryContext>(SubCategoryContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);

	const containerClasses = classNames(style.container, { [style.openInfo]: isOpenInfo });
	const subCategoryRowClasses = classNames(style.subCategory, style.row);
	const subCategoryNameClasses = classNames(style.subCategoryName);
	const categoryRowClasses = classNames(style.category, style.row);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const customerRowClasses = classNames(style.customer, style.row);
	const positionRowClasses = classNames(style.position, style.row, style.list);
	const isHiddenRowClasses = classNames(style.isHidden, style.row, style.list);
	const availableForRepetitionClasses = classNames(style.availableForRepetition, style.row, style.list);
	const actionRowClasses = classNames(style.action, style.row);

	const hiddenInRestaurants = data.restaurantsSubCategories.filter((el) => el.isHidden);
	const availableForRepetitionInRestaurants = data.restaurantsSubCategories.filter(
		(el) => el.isAvailableForRepetition,
	);

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<div className={subCategoryRowClasses}>
					<div className={style.imgWrapper}>
						<ImgUploaderByEntityId
							resource={RequestEntity.SubCategories}
							entityID={data.filePath ? data.id : ''}
							photoSize="Small"
							loaderSize="small"
							filePath={data.filePath}
						/>
					</div>
					<Text className={subCategoryNameClasses} translationKey={data.name} withTooltip={true} />
				</div>
				<Text className={categoryRowClasses} translationKey={data.categoryName} withTooltip={true} />
				<div className={restaurantRowClasses}>
					<RestaurantsList restaurants={data.restaurantsSubCategories} />
				</div>
				<Text className={customerRowClasses} translationKey={data.customerName} withTooltip={true} />
				<div className={positionRowClasses}>
					<PositionsList restaurants={data.restaurantsSubCategories} />
				</div>
				<div className={isHiddenRowClasses}>
					<RestaurantsList restaurants={hiddenInRestaurants} />
				</div>
				<div className={availableForRepetitionClasses}>
					<RestaurantsList restaurants={availableForRepetitionInRestaurants} />
				</div>
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={() => setIsOpenInfo(!isOpenInfo)}
						onClickDelete={() => setIDForDeletion(data.id)}
						URLWithIDToEdit={`/menu/subcategory/edit?subCategoryID=${data.id}`}
						size="smallBtn"
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} />
		</div>
	);
};

export default Item;
